import { createAsyncThunk } from "@reduxjs/toolkit";
const apiUrl = process.env.REACT_APP_API_URL;

export const invitationGet = createAsyncThunk("invitations/invitationGet", async (type) => {
  const typeReq = type === "invitations" ? "wedding" : type;
  const response = await fetch(`${apiUrl}/alternate-content/${typeReq}`);
  const data = await response.json();
  const dataReverse = data.reverse();

  return dataReverse;
});
